import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { Authentication,User } from '../model';
import { environment } from 'src/environments/environment';



@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<Authentication>;
    public currentUser: Observable<Authentication>;
    apiUrl = environment.serverUrl;
    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<Authentication>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): Authentication {
        return this.currentUserSubject.value;
    }

    login(user,password) {
        return this.http.post<any>(this.apiUrl+'/oauth/token',this.getParams(user,password),{ headers: this.getHeaders()})
            .pipe(map(auth => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                if (auth && auth.access_token) {
                    localStorage.setItem("email",user);
                    localStorage.setItem("token",auth.access_token)
                    localStorage.setItem('currentUser', JSON.stringify(auth));
                    this.currentUserSubject.next(auth);
                }

                return auth;
            }));
    }
    private getHeaders() {
        return new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Authorization', 'Basic ' + window.btoa('webapp:123456'));
    }
    private getParams(username:string,password:string) {
        return new HttpParams()
            .set('grant_type', 'password')
            .set('scope', 'read write')
            .set('username', username)
            .set('password', password);
    }
    logout() {
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }
    public isLoggedInUser(){
        return localStorage.getItem("currentUser")!=null;
    }
    public isAdmin(){
        return localStorage.getItem("roleName")=='ADMIN';
    }
    public isClient(){
        return localStorage.getItem("roleName")=='CLIENT';
    }
    public isKAM(){
        return localStorage.getItem("roleName")=='KAM';
    }
    public isRKAM(){
        return localStorage.getItem("roleName")=='RKAM';
    }
    public register(map:any): Observable<any> {
        const url = this.apiUrl+`/admin/register`;
        return this.http.post<any>(url,map); 
      }

      forgotPassword(email: string) {
        return this.http.get<any>(`${this.apiUrl}/public/user/forgotPassword/${email}`);
    
      }
}